import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { designTokens } from "@cinch-labs/design-system";
import cx from "classnames";
import React from "react";
import styles from "./loading-spinner.module.css";
const { color: palette  } = designTokens.customProperties.ds;
const DEFAULT_SIZE = 32;
export const LoadingSpinner = ({ backgroundCircleColor =palette.gainsboro , foregroundCircleColor =palette.deepPurple , size =DEFAULT_SIZE , className  })=>{
    const classNames = cx(styles.loadingSpinner, className);
    return /*#__PURE__*/ _jsxs("svg", {
        className: classNames,
        xmlns: "https://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        "data-testid": "LoadingSpinner",
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "16",
                cy: "16",
                r: "11",
                stroke: backgroundCircleColor
            }),
            /*#__PURE__*/ _jsx("path", {
                className: styles.foregroundCircle,
                d: "M5,16a11,11 0 1,0 22,0a11,11 0 1,0 -22,0",
                stroke: foregroundCircleColor
            })
        ]
    });
};
export default LoadingSpinner;
